import React from "react";
import "../App.scss";
import { updateState } from "../page/StateHelper";

const initialState = {
  checkedItems : new Array()
}

class CheckList extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = initialState;
    this.onCheckUncheck = this.onCheckUncheck.bind(this);
    this.hasChecked = this.hasChecked.bind(this);
  }

  componentDidMount() {
    let checked = this.props.checked || [];
    updateState(this, "checkedItems", checked);
    this.props.onChange(checked);
  }

  onCheckUncheck(item: any, e: any) {
    let isChecked = this.hasChecked(item);
    
    if (isChecked) {
      let currentChecked = Object.assign(this.state.checkedItems);
      let newChecked = currentChecked.filter((checkedItem: any) => {
        return (
          checkedItem[this.props.comparingField] != item[this.props.comparingField]
        );
      });
      updateState(this, "checkedItems", newChecked);
      this.props.onChange(this.props.refId, newChecked);

    } else {

      let newChecked = Object.assign(this.state.checkedItems);
      newChecked.push(item);
      updateState(this, "checkedItems", newChecked);
      this.props.onChange(this.props.refId, newChecked);
    }
  }

  hasChecked(item: any) {
    return (
      this.state.checkedItems &&
      this.state.checkedItems
        .map((c: any) => c[this.props.comparingField])
        .includes(item[this.props.comparingField])
    );
  }

  render() {
    let columns = this.props.columns || 2;
    const list =
      this.props.data &&
      this.props.data.map((item: any) => {
        return (
          <li style={{listStyleType:"none"}}>
            <input
              key={"cb_" + item[this.props.comparingField]}
              type="checkbox"
              {...this.props}
              onChange={(e) => this.onCheckUncheck(item, e.target.value)}
              checked={this.hasChecked(item)}
              style={{display:"inline-block"}}
            ></input>
            <label style={{marginLeft:"7px", marginBottom:"5px"}}>{item[this.props.labelField]}</label>
          </li>
        );
      });

    return <ul style={{columns:columns}}>{list}</ul>;
  }
}

export default CheckList;
